// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".super-button[data-v-bf6cd362]{border-radius:16px;padding:2.4rem 2rem;background:#e2f1f8;border:none;display:flex;justify-content:space-between;align-items:center;cursor:pointer;width:100%;margin-top:5.6rem}.super-button span[data-v-bf6cd362]{margin:0 .8rem;font-weight:600;font-size:3rem;line-height:30px;color:#096390}", ""]);
// Exports
module.exports = exports;
